// Catch all routes do not catch index: https://github.com/vercel/next.js/issues/10488
export { default, getServerSideProps } from './registerPage';
